import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Page from "../../components/Page";

import CenteredPageContentContainer from "../../components/CenteredPageContentContainer";
import PaperContainer from "../../components/PaperContainer";
import AssignEmployeesToShiftForm from "../../components/forms/AssignEmployeesToShiftForm";
import ShiftEmployeesList from "../../components/ShiftEmployeesList";
import ShiftEmployeesOfCompanyList from "../../components/ShiftEmployeesOfCompanyList";
import ShiftForm from "../../components/forms/ShiftForm";
import { FormMode } from "../../types/enums";

import CompanyEmployeeShiftConfirmation from "../../components/forms/CompanyEmployeeShiftConfirmation";

const credentials = JSON.parse(localStorage.getItem("credentials"));

const ActiveShiftDetailPage = (props) => (
  <Page enableGoBack title="Dienstaanvraag details">
    <CenteredPageContentContainer>
      <PaperContainer
        title={`Dienstaanvraag #${props.match.params.shift_id} details`}
        updateLink={
          credentials.user.isAdmin
            ? `/shift/${props.match.params.shift_id}/update`
            : null
        }
      >
        <ShiftForm
          isActiveShift={true}
          mode={FormMode.VIEW}
          shiftId={props.match.params.shift_id}
        />
        {credentials.user.type === "EMPLOYEE" && (
          <CompanyEmployeeShiftConfirmation
            shiftId={props.match.params.shift_id}
            employeeEmail={credentials.user.email}
          />
        )}
      </PaperContainer>

      {(credentials.user.type !== "EMPLOYEE" ||
        credentials.user.isSeniorEmployee) && (
        <Fragment>
          {credentials.user.isAdmin && (
            <PaperContainer title="Ingeplande medewerkers">
              <ShiftEmployeesList shiftId={props.match.params.shift_id} />
            </PaperContainer>
          )}

          {credentials.user.type === "COMPANY" && (
            <PaperContainer title="Ingeplande medewerkers">
              <ShiftEmployeesOfCompanyList
                shiftId={props.match.params.shift_id}
                companyEmail={credentials.user.email}
              />
            </PaperContainer>
          )}

          <PaperContainer title="Plan medewerkers in">
            <AssignEmployeesToShiftForm shiftId={props.match.params.shift_id} />
          </PaperContainer>
        </Fragment>
      )}
    </CenteredPageContentContainer>
  </Page>
);

ActiveShiftDetailPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      shift_id: PropTypes.string.isRequired,
    }),
  }),
};

export default ActiveShiftDetailPage;



// WEBPACK FOOTER //
// ./src/pages/Shift/ActiveShiftDetailPage.js